import { Box } from '@sequencehq/core-components'
import { ReactNode } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

type Props = {
  isVisible: boolean
  children: ReactNode
  innerMarginTop: string
}

export const CollapsibleArea = ({
  isVisible,
  children,
  innerMarginTop
}: Props) => (
  <AnimatePresence>
    {isVisible && (
      <motion.div
        initial={{ height: 0 }}
        animate={{ height: 'auto' }}
        exit={{ height: 0 }}
        style={{ overflow: 'hidden' }}
      >
        <Box marginTop={innerMarginTop}>{children}</Box>
      </motion.div>
    )}
  </AnimatePresence>
)
